<template>
    <div v-if="timezone && currentFormat" class="small m-auto">
        <span class="small">{{ `${currentFormat} ${offset} ${timezone}` }}</span>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import FPSManager from '../../FPSManager'
    import moment from 'moment-timezone'

    const fps = new FPSManager({ fps: 1 })

    export default {
        props: {
            confTimezone: {
                type: String,
                required: true,
            },
            paramTimezone: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                timezone: null,
                current: null,
                currentFormat: null,
            };
        },

        computed: {
            offset: function () {
                return this.helper.getOffsetFromUTC(this.timezone)
            },
        },

        created: function() {
            moment.locale('ja')

            this.timezone = this.paramTimezone
            this.elapse()
            this.countdown()

            bus.$on('timezone-updated', this.initTimezone)
        },

        beforeDestroy: function() {
            bus.$off('timezone-updated')
        },

        methods: {
            /**
             * タイムゾーン変更時
             *
             * @param {string} timezone
             */
            initTimezone: function (timezone) {
                if (this.confTimezone == 1) {
                    this.timezone = timezone
                }
            },

            /**
             * カウントダウン
             */
            countdown: function() {
                this.frame = requestAnimationFrame(this.countdown)
                fps.tick(this.elapse)
            },

            /**
             * 1秒経過時
             * 時刻表記を更新
             */
            elapse: function() {
                this.current = this.helper.userTimeNow(this.timezone)
                this.currentFormat = this.current.format('YYYY年M月D日(ddd) ah:mm')
            },
        },
    }
</script>
